import styled from 'styled-components'

import { barnesTheme } from '../../theme/barnesTheme'

/* ── Page container: elegant centered white ───────────────────────── */

export const PageContainer = styled.div`
  width: 210mm;
  max-width: 210mm;
  height: 297mm;
  margin: 0;
  padding: 0;
  position: relative;
  overflow: hidden;
  font-family: ${barnesTheme.fonts.body};
  box-sizing: border-box;
  background-color: ${barnesTheme.colors.white};
  display: flex;
  flex-direction: column;
  align-items: center;

  @media print {
    width: 100% !important;
    max-width: 100% !important;
    height: 297mm !important;
    min-height: 297mm !important;
    max-height: 297mm !important;
    margin: 0 !important;
    padding: 0 !important;
    position: relative !important;
    overflow: hidden !important;
    background-color: ${barnesTheme.colors.white} !important;
    display: flex !important;
    flex-direction: column !important;
    align-items: center !important;
    page-break-after: always !important;
    page-break-inside: avoid !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
`

/* ── Subtle border frame ──────────────────────────────────────────── */

export const BorderFrame = styled.div`
  position: absolute;
  top: 20px;
  left: 20px;
  right: 20px;
  bottom: 20px;
  border: 0.5px solid #e5e5e5;
  opacity: 0.5;
  pointer-events: none;

  @media print {
    position: absolute !important;
    top: 20px !important;
    left: 20px !important;
    right: 20px !important;
    bottom: 20px !important;
    border: 0.5px solid #e5e5e5 !important;
    opacity: 0.5 !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
`

/* ── Logo section ─────────────────────────────────────────────────── */

export const LogoWrapper = styled.div`
  margin-top: 300px;
  text-align: center;

  @media print {
    margin-top: 300px !important;
    text-align: center !important;
  }
`

/* ── Red accent line ──────────────────────────────────────────────── */

export const RedAccentLine = styled.div`
  width: 100px;
  height: 1.5px;
  background: ${barnesTheme.colors.accent};
  margin: 20px auto 0;

  @media print {
    width: 100px !important;
    height: 1.5px !important;
    background: ${barnesTheme.colors.accent} !important;
    margin: 20px auto 0 !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
`

/* ── Thank you title ──────────────────────────────────────────────── */

export const ThankYouTitle = styled.div`
  font-family: ${barnesTheme.fonts.heading};
  font-size: 13px;
  font-weight: ${barnesTheme.fontWeights.bold};
  color: ${barnesTheme.colors.primary};
  letter-spacing: 4px;
  text-align: center;
  margin-top: 32px;

  @media print {
    font-family: ${barnesTheme.fonts.heading} !important;
    font-size: 13px !important;
    font-weight: ${barnesTheme.fontWeights.bold} !important;
    color: ${barnesTheme.colors.primary} !important;
    letter-spacing: 4px !important;
    text-align: center !important;
    margin-top: 32px !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
`

/* ── Advisor photo ────────────────────────────────────────────────── */

export const AdvisorPhoto = styled.div`
  width: 140px;
  height: 140px;
  border-radius: 50%;
  border: 1px solid #e5e5e5;
  background: #f5f5f5;
  overflow: hidden;
  margin-top: 40px;
  flex-shrink: 0;

  @media print {
    width: 140px !important;
    height: 140px !important;
    border-radius: 50% !important;
    border: 1px solid #e5e5e5 !important;
    background: #f5f5f5 !important;
    overflow: hidden !important;
    margin-top: 40px !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
`

export const AdvisorPhotoImg = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;

  @media print {
    width: 100% !important;
    height: 100% !important;
    object-fit: cover !important;
  }
`

/* ── Advisor info ─────────────────────────────────────────────────── */

export const AdvisorName = styled.div`
  font-family: ${barnesTheme.fonts.heading};
  font-size: 18px;
  font-weight: ${barnesTheme.fontWeights.bold};
  color: ${barnesTheme.colors.primary};
  text-align: center;
  margin-top: 20px;

  @media print {
    font-family: ${barnesTheme.fonts.heading} !important;
    font-size: 18px !important;
    font-weight: ${barnesTheme.fontWeights.bold} !important;
    color: ${barnesTheme.colors.primary} !important;
    text-align: center !important;
    margin-top: 20px !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
`

export const AdvisorTitle = styled.div`
  font-family: ${barnesTheme.fonts.body};
  font-size: 10px;
  font-weight: ${barnesTheme.fontWeights.light};
  color: ${barnesTheme.colors.textLight};
  margin-top: 4px;
  text-align: center;

  @media print {
    font-size: 10px !important;
    font-weight: ${barnesTheme.fontWeights.light} !important;
    color: ${barnesTheme.colors.textLight} !important;
    margin-top: 4px !important;
    text-align: center !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
`

export const CardRedLine = styled.div`
  width: 55px;
  height: 1px;
  background: ${barnesTheme.colors.accent};
  margin: 16px auto;

  @media print {
    width: 55px !important;
    height: 1px !important;
    background: ${barnesTheme.colors.accent} !important;
    margin: 16px auto !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
`

export const AdvisorContact = styled.div`
  font-family: ${barnesTheme.fonts.body};
  font-size: 10px;
  font-weight: ${barnesTheme.fontWeights.light};
  color: ${barnesTheme.colors.text};
  text-align: center;
  line-height: 1.8;

  @media print {
    font-size: 10px !important;
    font-weight: ${barnesTheme.fontWeights.light} !important;
    color: ${barnesTheme.colors.text} !important;
    text-align: center !important;
    line-height: 1.8 !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
`

/* ── Office details ───────────────────────────────────────────────── */

export const OfficeName = styled.div`
  font-family: ${barnesTheme.fonts.heading};
  font-size: 11px;
  font-weight: ${barnesTheme.fontWeights.bold};
  color: ${barnesTheme.colors.primary};
  letter-spacing: 2px;
  text-align: center;
  margin-top: 28px;

  @media print {
    font-size: 11px !important;
    font-weight: ${barnesTheme.fontWeights.bold} !important;
    color: ${barnesTheme.colors.primary} !important;
    letter-spacing: 2px !important;
    text-align: center !important;
    margin-top: 28px !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
`

export const OfficeAddress = styled.div`
  font-family: ${barnesTheme.fonts.body};
  font-size: 9px;
  font-weight: ${barnesTheme.fontWeights.light};
  color: ${barnesTheme.colors.textLight};
  text-align: center;
  margin-top: 6px;
  line-height: 1.6;

  @media print {
    font-size: 9px !important;
    font-weight: ${barnesTheme.fontWeights.light} !important;
    color: ${barnesTheme.colors.textLight} !important;
    text-align: center !important;
    margin-top: 6px !important;
    line-height: 1.6 !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
`

/* ── Bottom section ───────────────────────────────────────────────── */

export const BottomSection = styled.div`
  margin-top: auto;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-bottom: 30px;

  @media print {
    margin-top: auto !important;
    width: 100% !important;
    display: flex !important;
    flex-direction: column !important;
    align-items: center !important;
    padding-bottom: 30px !important;
  }
`

export const HairlineSeparator = styled.div`
  width: 300px;
  height: 0.5px;
  background: #e5e5e5;
  margin: 0 auto 20px;

  @media print {
    width: 300px !important;
    height: 0.5px !important;
    background: #e5e5e5 !important;
    margin: 0 auto 20px !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
`

export const CitiesRow = styled.div`
  font-family: ${barnesTheme.fonts.body};
  font-size: 7px;
  font-weight: ${barnesTheme.fontWeights.light};
  color: ${barnesTheme.colors.textLight};
  letter-spacing: 2px;
  text-align: center;
  opacity: 0.5;

  @media print {
    font-size: 7px !important;
    font-weight: ${barnesTheme.fontWeights.light} !important;
    color: ${barnesTheme.colors.textLight} !important;
    letter-spacing: 2px !important;
    text-align: center !important;
    opacity: 0.5 !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
`

/* ── Seal watermark ───────────────────────────────────────────────── */

export const SealWatermark = styled.div`
  margin-top: 24px;
  opacity: 0.06;
  display: flex;
  align-items: center;
  justify-content: center;

  @media print {
    margin-top: 24px !important;
    opacity: 0.06 !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
`

export const SealSvg = styled.svg`
  width: 80px;
  height: 80px;

  @media print {
    width: 80px !important;
    height: 80px !important;
  }
`

/* ── Disclaimer ───────────────────────────────────────────────────── */

export const DisclaimerText = styled.div`
  font-family: ${barnesTheme.fonts.body};
  font-size: 6px;
  font-weight: ${barnesTheme.fontWeights.light};
  color: ${barnesTheme.colors.textLight};
  opacity: 0.4;
  text-align: center;
  margin-top: 16px;
  max-width: 400px;
  line-height: 1.4;

  @media print {
    font-size: 6px !important;
    font-weight: ${barnesTheme.fontWeights.light} !important;
    color: ${barnesTheme.colors.textLight} !important;
    opacity: 0.4 !important;
    text-align: center !important;
    margin-top: 16px !important;
    max-width: 400px !important;
    line-height: 1.4 !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
`

export const FooterArea = styled.div`
  width: 100%;
  margin-top: auto;

  @media print {
    width: 100% !important;
    margin-top: auto !important;
  }
`
